import { render, staticRenderFns } from "./IconArrowLeft.vue?vue&type=template&id=04328602&scoped=true&"
import script from "./IconArrowLeft.vue?vue&type=script&lang=js&"
export * from "./IconArrowLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04328602",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04328602')) {
      api.createRecord('04328602', component.options)
    } else {
      api.reload('04328602', component.options)
    }
    module.hot.accept("./IconArrowLeft.vue?vue&type=template&id=04328602&scoped=true&", function () {
      api.rerender('04328602', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconArrowLeft.vue"
export default component.exports